import RasterZonalStats from './RasterZonalStats'
import VectorClip from './VectorClip'
import RasterAverage from './RasterAverage'
import Intersection from './Intersection'

export default {
  RasterZonalStats,
  VectorClip,
  RasterAverage,
  Intersection
}


// WEBPACK FOOTER //
// ./src/api/wps/index.js